import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faPlus, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";


function index() {
  return (
    <div>
      <h3 className="mb-4">Home</h3>
      <div className="row">
        <div className="col-md-3 col-sm-12 col-lg-3">
          <div className="index-card">
            <h5>Hero Section</h5>
            <hr />
            <div className="d-flex justify-end">
              <Link to="/home-banner-list">
                <FontAwesomeIcon
                  icon={faEye}
                  className="text-primary-icon mx-2"
                  style={{ cursor: "pointer" }}
                />
              </Link>
              <Link to="/home-banner-add">
                <FontAwesomeIcon
                  icon={faPlus}
                  className="text-warning mx-2"
                  style={{ cursor: "pointer" }}
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-12 col-lg-3">
          <div className="index-card">
            <h5>Brand section <div className="tooltip-container">
              <FontAwesomeIcon
                icon={faCircleInfo}
                className="text-warning mx-2"
                style={{ cursor: "pointer" }}
              />
              <div className="tooltip">Show/Hide Brand section</div>
            </div></h5>
            <hr />
            <div className="d-flex justify-end small text-decoration-underline text-warning">
              <Link to="/enable-disable-brand">
                <FontAwesomeIcon
                  icon={faEdit}
                  className="text-warning"
                  style={{ cursor: "pointer" }}
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-12 col-lg-3">
          <div className="index-card">
            <h5>Featured</h5>
            <hr />
            <div className="d-flex justify-end small text-decoration-underline text-warning">
              <Link to="/featured">
                <FontAwesomeIcon
                  icon={faEdit}
                  className="text-warning mx-2"
                  style={{ cursor: "pointer" }}
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-12 col-lg-3">
          <div className="index-card">
            <h5>Best Seller</h5>
            <hr />
            <div className="d-flex justify-end small text-decoration-underline text-warning">
              <Link to="/add-best-seller">
                <FontAwesomeIcon
                  icon={faEdit}
                  className="text-warning mx-2"
                  style={{ cursor: "pointer" }}
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-12 col-lg-3">
          <div className="index-card">
            <h5>Banner  <div className="tooltip-container">
              <FontAwesomeIcon
                icon={faCircleInfo}
                className="text-warning mx-2"
                style={{ cursor: "pointer" }}
              />
              <div className="tooltip">Branding Details/Product Details</div>
            </div></h5>
            <hr />
            <div className="d-flex justify-end small text-decoration-underline text-warning">
              <Link to="/product-detail-add">
                <FontAwesomeIcon
                  icon={faEdit}
                  className="text-warning mx-2"
                  style={{ cursor: "pointer" }}
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-12 col-lg-3">
          <div className="index-card">
            <h5>Latest Products</h5>
            <hr />
            <div className="d-flex justify-end small text-decoration-underline text-warning">
              <Link to="/latest-product">
                <FontAwesomeIcon
                  icon={faEdit}
                  className="text-warning mx-2"
                  style={{ cursor: "pointer" }}
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
